import { render } from "./HomeCards.vue?vue&type=template&id=14850abb"
import script from "./HomeCards.vue?vue&type=script&lang=js"
export * from "./HomeCards.vue?vue&type=script&lang=js"
script.render = render

export default script